<template>
	<div class="history-parent">
        <div class="history-table">
            <layout-1
                :table_name="'Timesheet History'"
                :id=pageid
                :searchbar=false
                :height_limit="false"
                :navbar=false
                :term=term
            ></layout-1>
        </div>
        <div class="history-map">
            <l-map
                ref="map"
                style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; z-index: 1;"
                :zoom="zoom"
                :center="center"
                @ready="onMapReady">
                <l-marker v-for="marker in markers" :lat-lng="marker.latlng">
                    <l-popup class="popup">
                        {{marker.user}}<br>
                        {{marker.timestamp}}<br>
                        {{marker.comments}}
                    </l-popup>
                </l-marker>
                <l-polyline v-for="polyline in polylines" :lat-lngs="polyline.latlngs" :color="polyline.color"></l-polyline>
                <l-tile-layer :url="url"></l-tile-layer>
            </l-map>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
import {LMap, LTileLayer, LMarker, LPolyline, LPopup} from 'vue2-leaflet';

export default {
    props: {
		term: '',
		fromdatetime: '',
		todatetime: '',
		employeeid: '',
    },
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup,
        LPolyline
    },
	data(){
		return{
            pageid: PAGES.TIMESHEETS_HISTORY_PAGE,
            mapPageid: PAGES.TIMESHEET_MAP_PAGE,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 12,
            center: [33.7538924, -118.2421587],
            markers: [],
            lines: [],
            polylines: [],
		}
	},
    mounted(){
        this.search();
    },
    watch: {
        employeeid() { this.search(); },
        fromdatetime() { this.search(); },
        todatetime() { this.search(); },
    },
    methods: {
        onMapReady() {
            this.$refs.map.mapObject.invalidateSize();
        },
        setPolyLines() {
            this.polylines = [];
            for (let i = 0; i < this.lines.length; i++) {
                this.polylines.push({ latlngs: [], color: 'blue' });
                for (let j = 0; j < this.lines[i].length; j++) {
                    this.polylines[i].latlngs.push(this.markers[this.lines[i][j]].latlng);
                }
            }
        },
        search() {
            if (!this.employeeid) return;
            api.postData({
                type: 'search',
                data: {
                    pageid: this.mapPageid,
                    data: [
                        this.employeeid,
                        this.fromdatetime,
                        this.todatetime,
                    ],
                }
            }).then((res) => {
                let data = res.data.data.column_data;
                this.markers = [];
                this.lines = [];
                if (data[0].length == 0) return;
                this.lines.push([]);
                for (let i = 0; i < data.length; i++) {
                    let comment = data[i][5] + ', ' + data[i][6];
                    if (data[i][7] != -1) comment += ', 11-' + data[i][7];
                    if (data[i][8] != -1) comment += ', T-' + data[i][8];
                    this.markers.push({
                        latlng: [data[i][2], data[i][3]],
                        user: data[i][4],
                        comments: comment,
                    });
                    this.lines[0].push(i);
                }
                this.setPolyLines();
                this.$nextTick(() => {
                    const bounds = this.markers.map(m => m.latlng);
                    this.$refs.map.mapObject.fitBounds(bounds, { padding: [40, 40] });
                });
            });
        },
    },
}
</script>

<style scoped>

.history-parent {
    display: flex;
    flex-direction: row;
    height: calc(100vh - 200px);
    width: 100%;
    overflow: hidden;
}

.history-table {
    max-width: 60%;
    overflow-y: auto;
}

.history-map {
    flex: 1;
    position: relative;
}

</style>



// WEBPACK FOOTER //
// src/components/view/View_Timesheet_History.vue